//import validator from 'validator';
import isEmail from 'validator/es/lib/isEmail';
import isEmpty from 'validator/es/lib/isEmpty';
import request from '../libs/oc-request/oc-request';

import Popup from './popup';

export default new class Form {
    constructor() {
        this.sFormClass = 'form';

        this.sFormKpClass = '_form-kp';

        this.sFormMsgErrorClass = '_form-error-msg';
        this.sFormMsgErrorLgClass = '_form-error-msg-lg';
        this.sFormInputErrorTpl = '<div class="_form-error-msg text-size12 text-red"></div>';
        this.msg = {
            'empty': 'Обязательное поле',
            'emptyCheckbox': 'Обязательное поле',
            'incorect': 'Поле заполнено некорректно',
            'incorectName': 'Поле заполнено некорректно, не менее 2х символов',
        };

        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            let _this = this;
            document.addEventListener('submit', (obEvent) => {

                //форма "Запросить коммерческое предложение"
                if(obEvent.target.closest(`.${this.sFormKpClass}`)) {
                    obEvent.preventDefault();
                    this.kpSubmit(obEvent);
                }

            })

            // document.querySelectorAll(`.${this.sFormKpClass}`).forEach((form) => {
            //     this.isDisableBtnForm(form);
            // });
        });
    }

    kpSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    //формы обратной связи
    magicFormSubmit(obEvent) {
        if(this.validate(obEvent)) {
            const _this = this;
            const form = obEvent.target;
            const submitBtn = form.querySelector('[type="submit"]');
            submitBtn.classList.add('_preloader');

            let components = 'genericForm';

            if(form.getAttribute('data-components') && form.getAttribute('data-components') != '') {
                components = form.getAttribute('data-components');
            }

            // let data = {};
            // let formData = new FormData(form);
            // for (let key of formData.keys()) {
            //     data[key] = formData.get(key);
            // }

            // data['product'] = document.querySelector('#product.select .select__item[data-value="'+data['product']+'"]').textContent + " (id - "+data['product']+")"

            request.sendForm(form, components+'::onFormSubmit', {
                success: function(obData) {
                    submitBtn.classList.remove('_preloader');
                    Popup.popupMenuClose()
                    _this.resetForm(form);
                },
                error: _this.onError
            });

        }
    }

    onError(...args) {
        console.log(...args);
    }

    //валидация полей форма
    validate(obEvent) {
        let _this = this;
        let isValide = true;

        obEvent.target.closest(this.sFormClass).querySelectorAll('[data-required="true"]').forEach(element => {
            let value = element.value;

            if(isEmpty(value)) {
                //проверка на пустоту
                _this.showInputMsg(_this.msg['empty'], element);
                isValide = false;
            }
            else if(element.getAttribute('name') == "name" && value.length < 2) {
                //валидация имени
                _this.showInputMsg(_this.msg['incorectName'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "comment" && value.length < 2) {
                //валидация имени
                _this.showInputMsg(_this.msg['incorectName'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "email" && !isEmail(value)) {
                //валидация почты
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "inn" && value.length < 10) {
                //валидация инн
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "product" && value.length < 1) {
                //валидация выбора продукта
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "phone" && value.length < 11) {
                //валидация номера телефона
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('type') == "checkbox" && !element.checked) {
                //валидация checkbox
                _this.showInputMsg(_this.msg['emptyCheckbox'], element)
                isValide = false;
            }
            else {
                _this.deleteInputMsg(element)
            }
        });

        return isValide;
    }
    //валидация полей формы на пустоту
    validateEmpty(obEvent) {
        let _this = this;
        let isValide = true;

        obEvent.target.closest(this.sFormClass).querySelectorAll('[data-required="true"]').forEach(element => {
            let value = element.value;

            if(isEmpty(value)) {
                //проверка на пустоту
                isValide = false;
            }
            else if(element.getAttribute('type') == "checkbox" && !element.checked) {
                //валидация checkbox
                isValide = false;
            }
        });

        return isValide;
    }

    //проверка активной кнопки в форме
    isDisableBtnForm(form) {
        form.querySelectorAll(`[data-required="true"]`).forEach((input) => {
            input.addEventListener('input', (obEvent) => {
                this.validate(obEvent)
            })
            input.addEventListener('change', (obEvent) => {
                this.validate(obEvent)
            })
        });
    }

    //отображение ошибки/сообщения для инпута
    showInputMsg(message, input) {
        let div = input.closest('div');

        input.classList.add('border-b')
        input.classList.add('border-red')
        input.classList.add('red')

        if(input.closest('.select')) {
            input.closest('.select').classList.add('error')
        }

        if(!div.querySelector(`.${this.sFormMsgErrorClass}`)) {
            let sFormInputErrorTpl = document.createElement("div");
            sFormInputErrorTpl.className = "_form-error-msg text-size12 text-red";
            div.appendChild(sFormInputErrorTpl)
        }

        div.querySelector(`.${this.sFormMsgErrorClass}`).textContent = message
    }
    //удаление ошибок
    deleteInputMsg(input) {
        input.classList.remove('border-b')
        input.classList.remove('border-red')
        input.classList.remove('red')
        if(input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`)) {
            input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`).remove()
        }
        if(input.closest('.select')) {
            input.closest('.select').classList.remove('error')
        }
    }
    //отображение ошибки/сообщения для формы после кнопки
    showFormMsg(message, form) {
        if(form.querySelector(`.${this.sFormMsgErrorLgClass}`)) {
            form.querySelectorAll(`.${this.sFormMsgErrorLgClass}`).forEach((msg) => {
                msg.textContent = message
            })
        }
    }
    //удаление ошибки/сообщения для формы после кнопки
    deleteFormMsg(form) {
        if(form.querySelector(`.${this.sFormMsgErrorLgClass}`)) {
            form.querySelectorAll(`.${this.sFormMsgErrorLgClass}`).forEach((msg) => {
                msg.textContent = ''
            })
        }
    }
    //очищенеи формы
    resetForm(form) {
        form.reset();
        // form.querySelector('.button').classList.add('disable');
        form.querySelectorAll('.select').forEach((select) => {
            if (select.querySelector('input:checked')) {
                select.querySelectorAll('input:checked').forEach((item) => {
                    item.checked = false;
                });
            }
            const currentInput = select.querySelector('.select__input');
            const currentText = select.querySelector('.select__current');

            currentText.textContent = 'Ничего не выбрано'
            currentText.removeAttribute('style')
            select.classList.remove('is-selected');
            currentInput.setAttribute("value", "")

            select.querySelectorAll('.select__item').forEach((item) => {
                item.removeAttribute('active')
            });
        })
    }
}();